import type { FC } from 'react'
import React, { useCallback, useEffect, useState } from 'react'
import { CwsH4 } from '@components/cws'
import { SpoilerChevron } from '@ui/icons/common'
import clsx from 'clsx'

interface SectionProps {
  title: string
  open?: boolean
  onHeadingClick?: (value: boolean) => any
  children?: React.ReactNode
}

export const Section: FC<SectionProps> = (props) => {
  const { title, children, open = false, onHeadingClick } = props

  const [isCollapsed, setIsCollapsed] = useState(!open)

  const handleChevronClick = useCallback(() => {
    setIsCollapsed((prevIsCollapsedState) => !prevIsCollapsedState)
    onHeadingClick?.(!open)
  }, [open, onHeadingClick])
  useEffect(() => {
    setIsCollapsed(!open)
  }, [open])
  return (
    <div className="flex flex-col px-4 py-6">
      <div className="flex flex-row justify-between cursor-pointer" onClick={handleChevronClick}>
        <CwsH4 size="lead" className="flex-1-auto">
          {title}
        </CwsH4>
        <div className="w-4 h-auto flex-0-auto m-auto cursor-pointer">
          <SpoilerChevron open={!isCollapsed} className="text-midnight w-4 h-4 object-contain" />
        </div>
      </div>
      <div className={clsx('flex flex-col space-y-4')}>{!isCollapsed && children}</div>
    </div>
  )
}
